import { apiClient } from 'pobble-components/dist/api'

const apiSubmitContribution = (assessmentFileId, contribution, params) =>
  apiClient.post(
    `v3/assessment_files/${assessmentFileId}/contributions`,
    contribution,
    { params }
  )

const apiSubmitContributionReply = (
  assessmentFileId,
  parentId,
  contribution,
  params
) =>
  apiClient.post(
    `v3/assessment_files/${assessmentFileId}/contributions`,
    { content: contribution.content, parent_id: parentId },
    { params }
  )

const apiSubmitContributionWithAttachment = (
  assessmentFileId,
  contribution,
  params
) => {
  const formData = new FormData()
  formData.append('content', contribution.content)
  formData.append('file', contribution.file)
  return apiClient.post(
    `v3/assessment_files/${assessmentFileId}/contributions`,
    formData,
    { params }
  )
}

const apiMarkContributionAsConclusion = (contributionId, params) =>
  apiClient.put(`v3/contributions/${contributionId}/mark_as_conclusion`, null, {
    params
  })

const apiUnmarkContributionAsConclusion = (contributionId, params) =>
  apiClient.put(
    `v3/contributions/${contributionId}/unmark_as_conclusion`,
    null,
    {
      params
    }
  )

const apiDeleteContribution = (contributionId, params) =>
  apiClient.delete(`v3/contributions/${contributionId}/`, {
    params
  })

const apiEditContribution = (contributionId, body, params) =>
  apiClient.put(`v3/contributions/${contributionId}/`, body, {
    params
  })

export {
  apiSubmitContribution,
  apiSubmitContributionWithAttachment,
  apiMarkContributionAsConclusion,
  apiUnmarkContributionAsConclusion,
  apiDeleteContribution,
  apiEditContribution,
  apiSubmitContributionReply
}
